/*
 *  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
 *  ~ No part of this publication may be reproduced, distributed,
 *  ~ or transmitted in any form or by any means, including photocopying, recording,
 *  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
 *  ~ except in the case of brief quotations embodied in critical
 *  ~ reviews and certain other noncommercial uses permitted by copyright law.
 *  ~ Author : BS
 *  ~ Date : 2/14/23, 3:35 PM
 */

export enum ExportOptionsEnum {
  pdf = 'P',
  csv = 'C',
}
